/** @jsxImportSource @emotion/react */
import React from 'react';
import { MainBlock } from './styles';
import { AddPlaceholder } from 'modules/template-editor/ui/components/editor/left-toolbar/add-placeholders/add-placeholder';
import { AddShape } from './add-shape';
import { AddText } from './add-text';
import { PenTool } from './pen-tool';
import { AddImage } from './add-image';
import { Copy } from './copy';
import { Undo } from './undo';
import { Redo } from './redo';
import { Delete } from './delete';
import { Group } from './group';

function LeftToolbar() {
  return (
    <MainBlock>
      <AddPlaceholder />
      <AddShape />
      <AddText />
      <PenTool />
      <AddImage />
      <Copy />
      <Group />
      <Undo />
      <Redo />
      <Delete />
    </MainBlock>
  );
}

export default LeftToolbar;
